import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/tools/CopyButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
